/**
 * «История» клиента во вкладке «Новый год» (29.10.2026): лента заметок к клиенту (телефону) — кто и когда написал, новые сверху.
 * Добавить может любой из офиса, удалить — автор или ЕО (сервер отдаёт can_delete и проверяет сам). История игр — «Инфо», не здесь.
 */
import { useEffect, useRef, useState } from "react";
import { AutoGrowTextarea } from "../../components/shared";
import { fmtStamp } from "./nyModel";
import { errText, useNyNotes } from "./useNy";
import ny from "./dcNy.module.css";

const MAX = 2000;

/** ✕ с подтверждением вторым нажатием (удаление необратимо); двойной тап — не подтверждение. */
export function NyDel({ onDelete, label = "Удалить", idle = "✕" }: { onDelete: () => Promise<void>; label?: string; idle?: string }) {
  const [arm, setArm] = useState(false);
  const [busy, setBusy] = useState(false);
  const armedAt = useRef(0);
  useEffect(() => { if (!arm) return; const t = window.setTimeout(() => setArm(false), 3000); return () => window.clearTimeout(t); }, [arm]);
  const click = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (busy) return;
    if (!arm) { armedAt.current = Date.now(); setArm(true); return; }
    if (Date.now() - armedAt.current < 400) return;
    setBusy(true);
    try { await onDelete(); } finally { setBusy(false); setArm(false); }
  };
  return (
    <button type="button" className={`${ny.del} ${arm ? ny.delArm : ""}`} onClick={(e) => { void click(e); }} disabled={busy}
      title={arm ? "Ещё раз — удалить" : label} aria-label={arm ? "Ещё раз — удалить" : label}>{busy ? "…" : arm ? "Удалить?" : idle}</button>
  );
}

export function NyNotes({ cardRef, onChanged, onToast }: { cardRef: number; onChanged: () => void; onToast: (m: string) => void }) {
  const { notes, error, add, remove } = useNyNotes(cardRef, onChanged);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const save = async () => {
    const t = text.trim();
    if (!t || busy) return;
    setBusy(true); setErr(null);
    try { await add(t); setText(""); } catch (e) { setErr(errText(e, "Не удалось сохранить заметку")); } finally { setBusy(false); }
  };
  const del = async (id: number) => {
    try { await remove(id); onToast("Заметка удалена"); } catch (e) { onToast(errText(e, "Не удалось удалить заметку")); }
  };

  return (
    <div className={ny.panel}>
      <div className={ny.add}>
        <AutoGrowTextarea className={ny.input} value={text} onChange={(e) => { setText(e.target.value); setErr(null); }} maxLength={MAX} minRows={2} maxHeight={220}
          placeholder="О чём договорились, что обещали…" aria-label="Новая заметка" />
        <button type="button" className={ny.btn} onClick={() => { void save(); }} disabled={busy || !text.trim()}>{busy ? "…" : "Добавить"}</button>
      </div>
      {err ? <div className={ny.err} role="alert">{err}</div> : null}
      {error && !notes ? <div className={ny.err}>Ошибка загрузки: {error}</div>
        : !notes ? <div className={ny.muted}>Загрузка…</div>
        : notes.length === 0 ? <div className={ny.muted}>Заметок пока нет — первая появится здесь.</div>
        : notes.map((n) => (
          <div key={n.id} className={ny.note}>
            <div className={ny.noteHead}>
              <b>{n.author_name || "—"}</b><span>{fmtStamp(n.created_at)}</span>
              {n.can_delete ? <NyDel onDelete={() => del(n.id)} label="Удалить заметку" /> : null}
            </div>
            <div className={ny.noteText}>{n.text}</div>
          </div>
        ))}
    </div>
  );
}
